import React, { useEffect, useRef, useState } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import EpdRoutes from 'routes/EpdRoutes';
import AuthService from 'services/AuthService';
import emailConfirmIcon from './email-confirm.png';
import AuthStatusPage from 'components/auth/AuthStatusPage';
import { HyperLink } from 'styles/Styles.styled';

const ConfirmEmail: React.FC<RouteComponentProps> = ({ history, location }) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const sentRequestRef = useRef<boolean>(false);
  const params = new URLSearchParams(location.search);
  const userId = params.get('userId');
  const token = params.get('token');

  useEffect(() => {
    const confirmEmail = async () => {
      if (sentRequestRef.current) {
        // Prevent optimistic concurrency issue in StrictMode
        return;
      }
      sentRequestRef.current = true;

      if (!userId || !token) {
        console.error('Missing required query parameters');
        history.replace(EpdRoutes.account.register.userError);
        return;
      }

      try {
        await AuthService.confirmEmail({
          userId,
          token,
        });
        setIsLoading(false);
      } catch (e) {
        console.error('Email confirmation request failed', e);
        history.replace(EpdRoutes.account.register.userError);
        return;
      }
    };

    confirmEmail();
  }, [token, userId]);

  if (isLoading) {
    return <AuthStatusPage imageSkeleton title="Confirming your email..." />;
  }

  return (
    <AuthStatusPage
      imageSrc={emailConfirmIcon}
      imageAlt="Success"
      title="Your email address has been confirmed!"
      message="You can now start using the EPD Portal."
      link={
        AuthService.isAuthenticated() ? (
          <HyperLink as={Link} to={EpdRoutes.dashboard}>
            Go to the dashboard
          </HyperLink>
        ) : (
          <HyperLink as={Link} to={EpdRoutes.login}>
            Back to login page
          </HyperLink>
        )
      }
    />
  );
};

export default ConfirmEmail;
